"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RemoteBackend = function () {
  function RemoteBackend(baseUrl) {
    var _this = this;

    (0, _classCallCheck3.default)(this, RemoteBackend);

    this.getBaseUrl = function () {
      return _this.baseUrl;
    };

    this.getInstance = function () {
      return _this.instance;
    };

    this.prepEndpoint = function (endpoint, params) {
      var remote = endpoint.startsWith("http") ? endpoint : _this.baseUrl + "/" + endpoint;
      if (Object.keys(params).length === 0) {
        return remote;
      }
      var queries = Object.keys(params).map(function (key) {
        var value = params[key];
        if (value === null) {
          return key;
        }
        if (Object.prototype.toString.call(value) === "object Array") {
          value = value.join(",");
        }
        value = encodeURIComponent(value);
        return key + "=" + value;
      });
      var formattedParams = queries.reduce(function (acl, curr) {
        return acl + "&" + curr;
      });
      return remote + "?" + formattedParams;
    };

    this.fetch = function (endpoint) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var method = arguments[2];
      var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      // eslint-disable-next-line no-undef
      var isBodyFormData = body instanceof FormData;
      var url = _this.prepEndpoint(endpoint, query);
      if ((typeof body === "undefined" ? "undefined" : (0, _typeof3.default)(body)) !== "object") {
        throw new Error("The body params should be an object");
      }
      var authHeaders = JSON.parse(sessionStorage.getItem("helenAuthHeaders"));
      var headers = Object.assign({}, isBodyFormData ? undefined : { "Content-Type": "application/json" }, authHeaders);
      var options = {
        method: method,
        headers: headers
      };
      if (method.toLowerCase() !== "get") {
        if (isBodyFormData) {
          options.body = body;
        } else {
          options.body = JSON.stringify(body);
        }
      }
      return fetch(url, options);
    };

    this.fetchJson = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(endpoint, query, method, body) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.fetch(endpoint, query, method, body);

              case 3:
                response = _context.sent;

                if (!(response.status >= 200 && response.status <= 300)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return response.json();

              case 7:
                return _context.abrupt("return", _context.sent);

              case 8:
                return _context.abrupt("return", Promise.reject(response));

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                if (!(_context.t0.name === "SyntaxError")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", Promise.resolve());

              case 15:
                throw new Error("NetworkError");

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 11]]);
      }));

      return function (_x3, _x4, _x5, _x6) {
        return _ref.apply(this, arguments);
      };
    }();

    this.setToken = function (token) {
      var headers = JSON.parse(sessionStorage.getItem("helenAuthHeaders")) || {};
      Object.assign(headers, {
        token: token
      });
      sessionStorage.setItem("helenAuthHeaders", JSON.stringify(headers));
    };

    this.baseUrl = baseUrl || process.env.REACT_APP_API_BASE_URL || "";
    this.instance = "";
  }

  (0, _createClass3.default)(RemoteBackend, [{
    key: "setBaseUrl",
    value: function setBaseUrl(baseUrl) {
      this.baseUrl = baseUrl;
    }
  }, {
    key: "setInstance",
    value: function setInstance(instance) {
      this.instance = instance;
    }
  }]);
  return RemoteBackend;
}();

exports.default = RemoteBackend;


//////////////////
// WEBPACK FOOTER
// ../sdk/lib/RemoteBackend.js
// module id = 300
// module chunks = 0